export const assetUrl = (filename: string): string =>
  `${import.meta.env.VITE_APP_FOLDER_PATH}/attached_assets/${filename}`;